module.exports = __webpack_public_path__ + "static/media/1POLICY18.b9b3474d.jpg";